export interface FriendsListState {
    isReady             : boolean;
    isSearchFinished    : boolean;
    friends             : any;
    error?              : any;
}

export const FRIENDS_LIST_INIT_STATE: FriendsListState = {
    isReady             : false,
    isSearchFinished    : false,
    friends             : null,
    error               : null,
};
